exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-order-info[data-v-2c7a8d2d]{width:100%}.order-info-title[data-v-2c7a8d2d]{background-color:#eee}.delivery-order-info td[data-v-2c7a8d2d]{text-align:center!important;border:1px solid #e0d9d9;padding:6px;vertical-align:middle!important}", ""]);

// exports
